import React from 'react';

import WxCopilotHost from 'components/WxCopilotHost';

export default function CueTrigger() {
  return (
    <>
      {/* The UMD's shadow root needs a sized, in-flow target in the host nav. */}
      <div
        id="wx-cue-trigger"
        style={{
          height: 40,
          display: 'inline-flex',
          alignItems: 'center',
          flexShrink: 0,
        }}
      />
      <WxCopilotHost
        mode="trigger"
        openMethod="nav_bar"
        buttonClassName="h-10"
      />
    </>
  );
}
